import { isEmpty } from 'es-toolkit/compat';
import { createSelector } from 'reselect';
import Home from '../../../models/home/Home';
import { HOME_REDUCER } from './reducer';

const _selectHomesReducer = (state) => state[HOME_REDUCER];
const _selectHomes = (state) => _selectHomesReducer(state).homes;
const _selectHomeById = (state, id) =>
  id ? _selectHomes(state)[id.toLowerCase()] : {};

/**
 * Reselect 4's `MergeParameters` cannot recover a parameter tuple from an input
 * selector whose own parameters are implicitly `any`, so it types this as
 * `(state) => …` and every `selectHomeById(state, id)` call is reported as
 * passing too many arguments. This states the signature it actually has.
 *
 * @type {(state: any, id?: string) => Home | null}
 */
export const selectHomeById = createSelector(_selectHomeById, (home) =>
  !isEmpty(home) ? new Home(home) : null,
);
